export default {
    url: 'cost-saving',
    include: ['us', 'ca', 'za'],
};
